import React from 'react';
import DialogContentText from '@mui/material/DialogContentText';

const handlePrivacyPolicyClick = () => {
    window.open('https://www.zippyops.com/privacy-policy', '_blank');
};


const TrainerTermsAndCondition = () => {
    return (
        <>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 0,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                <span><strong>PURPOSE :</strong></span>
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                Collab.labasservice.com is intended only to serve as a preliminary medium of contact and exchange of information for its users / members / visitors
                who have a bona fide intention to contact and/or be contacted for the purposes related to genuine existing Training requirements and for other career enhancement services.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                <span><strong>USE TO BE IN CONFORMITY WITH THE PURPOSE :</strong></span>
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                Collab.labasservice.com (and related products) or service or product that is subscribe to or used (whether the same is paid for by you or not)
                is meant for the Purpose and <strong>only the exclusive use of the subscriber/registered user.</strong> Copying or downloading or recreating or sharing passwords
                or sublicensing or sharing in any manner which is not in accordance with these terms, <strong>is a misuse</strong> of the platform or service or product and ZippyOPS
                reserves its rights to act in such manner as to protect its loss of revenue or reputation or claim damages including stopping your service or access
                and reporting to relevant authorities. In the event you are found to be copying or misusing or transmitting or crawling any data or photographs or graphics
                or any information available on Collab.labasservice.com for any purpose other than that being a bona fide Purpose, we reserve the right to take such action
                that we deem fit including stopping access and claiming damages.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                The site is a public site with free access and ZippyOPS assumes no liability for the quality and genuineness of responses. ZippyOPS Consulting Services LLP cannot monitor
                the responses that a person may receive in response to information he/she has displayed on the site. The individual/company would have to conduct its own background checks
                on the bona fide nature of all response(s).
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                You give us permission to use the information about actions that you have taken on Collab.labasservice.com in connection with ads, offers and other content (whether sponsored or not)
                that we display across our services, without any compensation to you. We use data and information about you to make relevant suggestions and recommendation to you and others.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                The platform may contain links to third party websites, these links are provided solely as convenience to You and the presence of these links should not under any circumstances be considered
                as an endorsement of the contents of the same, if You chose to access these websites you do so at your own risk.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                Whilst using this platform an obligation is cast upon you to only provide true and correct information and in the case of creating a profile you undertake to at all times keep the information
                up to date. ZippyOPS Consulting Services LLP will not be liable on account of any inaccuracy of information on this web site. It is the responsibility of the visitor to further research the information
                on the site. Any breach of privacy or of the information provided by the consumer to ZippyOPS Consulting Services LLP to be placed on the website by technical or any other means is not the responsibility
                of ZippyOPS Consulting Services LLP ZippyOPS Consulting Services LLP does not guarantee confidentiality of information provided to it by any person acquiring/using all/any information displayed on the
                collab.labasservice.com website or any of its other websites / domains owned and operated by ZippyOPS Consulting Services LLP.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                ZippyOPS Consulting Services LLP does not share personally identifiable data of any individual with other companies / entities without obtaining permission except with those acting as our agents.
                ZippyOPS Consulting Services LLP shall share all such information that it has in its possession in response to legal process, such as a court order or subpoena. The user shall not utilize the services
                offered by collab.labasservice.com/ZippyOPS in any manner to impair the interests and functioning of collab.labasservice.com/ZippyOPS. The user undertakes not to duplicate, download publish, modify, and
                distribute material on collab.labasservice.com unless specifically authorized by ZippyOPS in this regard.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                The user undertakes to use collab.labasservice.com for his/her own purposes. Using content from collab.labasservice.com for derivative works with a commercial motive without prior written consent from ZippyOPS
                is strictly prohibited.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                Users undertake that the services offered by collab.labasservice.com/ ZippyOPS shall not be utilized to upload, post, email, transmit or otherwise make available either directly or indirectly, any unsolicited
                bulk e-mail or unsolicited commercial e-mail. ZippyOPS reserves the right to filter and monitor and block the emails sent by you/user using the servers maintained by ZippyOPS to relay emails. All attempts shall be
                made by ZippyOPS and the user to abide by International Best Practices in containing and eliminating Spam.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                Users shall not spam the platform maintained by collab.labasservice.com / ZippyOPS or indiscriminately and repeatedly post Trainings/forward mail indiscriminately etc. Any conduct of the user in violation of this clause
                shall entitle ZippyOPS to forthwith terminate all services to the user without notice and to forfeit any amounts paid by him.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                The user shall not upload, post, transmit, publish, or distribute any material or information that is unlawful, or which may potentially be perceived as being harmful, threatening, abusive, harassing, defamatory, libelous, vulgar,
                obscene, or racially, ethnically, or otherwise objectionable.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                The user expressly states that the resume/insertion or information/ data being fed into the network of ZippyOPS Consulting Services LLP by the user is correct and complete in all respects and does not contain any false, distorted, manipulated,
                fraudulent or misleading facts or averments. ZippyOPS Consulting Services LLP expressly disclaims any liability arising out of the said resume insertion/information/ data so fed into the network of ZippyOPS Consulting Services LLP by the user.
                Further, the user agrees to indemnify ZippyOPS Consulting Services LLP for all losses incurred by ZippyOPS Consulting Services LLP due to any false, distorted, manipulated, defamatory, libelous, vulgar, obscene, fraudulent or misleading facts or
                otherwise objectionable averments made by the user on the network of ZippyOPS.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                The User is solely responsible for maintaining confidentiality of the User password and user identification and all activities and transmission performed by the User through his user identification and shall be solely responsible for carrying out
                any online or off-line transaction involving credit cards / debit cards or such other forms of instruments or documents for making such transactions and ZippyOPS Consulting Services LLP assumes no responsibility or liability for their improper use
                of information relating to such usage of credit cards / debit cards used by the subscriber online / off-line.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                The User/Subscriber/Visitor to Collab.labasservice.com and/or its affiliated websites does hereby specifically agree that he/she shall, at all times, comply with the requirements of the Information Technology Act, 2000 as also rules, regulations, guidelines,
                bye laws and notifications made thereunder, while assessing or feeding any resume/ insertion or information/data into the computers, computer systems or computer network of ZippyOPS. The said User/ subscriber/ visitor to Collab.labasservice.com and/or its affiliated
                websites does further unequivocally declare that in case he violates any provisions of the Information Technology Act, 2000 and/or rules, regulations, guidelines, byelaws and notifications made thereunder, he shall alone be responsible for all his acts, deeds and things
                and that he alone shall be liable for civil and criminal liability there under or under any other law for the time being in force.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                The User is solely responsible for obtaining, at his own cost, all licenses, permits, consents, approvals and intellectual property or other rights as may be required by the user for using the Service.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                <span><strong>THE USER REPRESENTS, WARRANTS AND COVENANTS THAT ITS USE OF COLLAB.LABASSERVICE.COM SHALL NOT BE DONE IN A MANNER SO AS TO :</strong></span>
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    marginLeft: 15,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                a.&nbsp;&nbsp;&nbsp;Access the Platform for purposes of extracting content to be used for training a machine learning or &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                AI model, without the express prior written permission.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    marginLeft: 15,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                b.&nbsp;&nbsp;&nbsp;Violate any applicable local, provincial, state, national or international law, statute, ordinance, rule or &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                &nbsp;regulation.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    marginLeft: 15,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                c.&nbsp;&nbsp;&nbsp;Interfere with or disrupt computer networks connected to Collab.labasservice.com.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    marginLeft: 15,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                d.&nbsp;&nbsp;&nbsp;Impersonate any other person or entity or make any misrepresentation as to your employment by or &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;affiliation
                with any other person or entity.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    marginLeft: 15,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                e.&nbsp;&nbsp;&nbsp;Forge headers or in any manner manipulate identifiers to disguise the origin of any user information.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    marginLeft: 15,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                f.&nbsp;&nbsp;&nbsp;Interfere with or disrupt the use of Collab.labasservice.com by any other user, nor "stalk", threaten, or &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;in any manner harass another user.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    marginLeft: 15,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                g.&nbsp;&nbsp;&nbsp;Use Collab.labasservice.com in such a manner as to gain unauthorized entry or access to the &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;computer systems of others.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    marginLeft: 15,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                h.&nbsp;&nbsp;&nbsp;Reproduce, copy, modify, sell, store, distribute or otherwise exploit for any commercial purposes &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Collab.labasservice.com,
                or any component thereof (including, but not limited to any materials or &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;information accessible through Collab.labasservice.com).
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    marginLeft: 15,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                i.&nbsp;&nbsp;&nbsp;Use content from the Site for derivative works with a commercial motive without prior written &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;consent of the ZippyOPS.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    marginLeft: 15,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                j.&nbsp;&nbsp;&nbsp;Use any device, software, or routine to interfere or attempt to interfere with the proper working of &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Collab.labasservice.com; or
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    marginLeft: 15,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                k.&nbsp;&nbsp;&nbsp;Impose an unreasonable or disproportionately large load on Collab.labasservice.com infrastructure.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    marginLeft: 15,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                l.&nbsp;&nbsp;&nbsp;Spam Collab.labasservice.com/ZippyOPS by indiscriminately and repeatedly posting content or &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;forwarding mail that may
                be considered spam etc.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    marginLeft: 15,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                m.&nbsp;&nbsp;Access data not intended for you or log into server or account that you are not authorized to access.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    marginLeft: 15,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                n.&nbsp;&nbsp;&nbsp;Constitute an act of reverse engineering, decompiling, disassembling, deciphering or otherwise &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;attempting to derive the source code for the Site or any related technology
                or any part thereof.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    marginLeft: 15,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                o.&nbsp;&nbsp;&nbsp;Engage in "framing," "mirroring," or otherwise simulating the appearance or function of the Site
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    marginLeft: 15,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                p.&nbsp;&nbsp;&nbsp;Attempt to probe, scan, or test the vulnerability of a system or network.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    marginLeft: 15,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                q.&nbsp;&nbsp;&nbsp;Use automated means to crawl and/or scrape content from Collab.labasservice.com and to &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;manually scrape content from Collab.labasservice.com.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    marginLeft: 15,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                r.&nbsp;&nbsp;&nbsp;The Site uses technological means to exclude Robots etc. from crawling it and scraping content. You &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;undertake not to circumvent these methods.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    marginLeft: 15,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                s.&nbsp;&nbsp;&nbsp;Access the Site except through the interfaces expressly provided by ZippyOPS.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    marginLeft: 15,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                t.&nbsp;&nbsp;&nbsp;&nbsp;Attempt or breach security or authentication measures without proper authorization.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    marginLeft: 15,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                u.&nbsp;&nbsp;&nbsp;Providing deep links into Collab.labasservice.com without prior permission of ZippyOPS is &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;prohibited. Extracting data from Collab.labasservice.com
                using any automated process such as &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;spiders, crawlers etc.
                or through any manual process for a purpose which has not been authorised in &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;writing.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    marginLeft: 15,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                v.&nbsp;&nbsp;&nbsp;Upload, post, email, transmit or otherwise make available either directly or indirectly, any unsolicited &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;bulk e-mail or unsolicited commercial e-mail.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    marginLeft: 15,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                w.&nbsp;&nbsp;&nbsp;Subscribers shall under no circumstance sublicense, assign, or transfer the License, and any &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;attempt at such sublicense, assignment or transfer is void.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    marginLeft: 15,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                x.&nbsp;&nbsp;&nbsp;Constitute hosting, modifying, uploading, posting, transmitting, publishing, or distributing any &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;material or information
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    marginLeft: 70,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                a.&nbsp;&nbsp;&nbsp;For which you do not have all necessary rights and licenses.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    marginLeft: 70,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                b.&nbsp;&nbsp;&nbsp;Which infringes, violates, breaches, or otherwise contravenes the rights of any third party, &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;including any copyright, trademark, patent, rights of
                privacy or publicity or any other &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;proprietary right.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    marginLeft: 70,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                c.&nbsp;&nbsp;&nbsp;Which contains a computer virus, or other code, files or programs intending in any manner &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;to disrupt or interfere with the functioning of Collab.labasservice.com,
                or that of other &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;computer systems.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    marginLeft: 70,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                d.&nbsp;&nbsp;&nbsp;That is grossly harmful, harassing, invasive of another's privacy, hateful, disparaging, &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;relating to money laundering or unlawful, or which may potentially be perceived as being
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;harmful, threatening, abusive, harassing,
                defamatory, libelous/blasphemous, vulgar, &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;obscene, or racially, ethnically, or otherwise unlawful in any manner whatsoever.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    marginLeft: 70,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                e.&nbsp;&nbsp;&nbsp;Which constitutes or encourages conduct that would constitute a criminal offence, give rise &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;to other liability, or otherwise violate applicable law.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    marginLeft: 70,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                f.&nbsp;&nbsp;&nbsp;That deceives or misleads the addressee about the origin of such messages or &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;communicates any information which is grossly offensive or menacing in nature.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    marginLeft: 70,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                g.&nbsp;&nbsp;&nbsp;That belongs to another person and to which the user does not have any right to.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    marginLeft: 70,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                h.&nbsp;&nbsp;&nbsp;That harm minors in any way.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    marginLeft: 70,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                i.&nbsp;&nbsp;&nbsp;&nbsp;That threatens the unity, integrity, defence, security or sovereignty of India, friendly relations &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;with foreign states, or public order or causes
                incitement to the commission of any &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;cognisable offence or prevents
                investigation of any offence or is insulting any other nation.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                The user shall not infringe on any intellectual property rights of any person / entity or retain information / download any information from any computer system or otherwise with an intention to do so.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                ZippyOPS Consulting Services LLP will make best efforts to do so but does not warrant that any of the web sites or any affiliate site(s) or network system linked to it is free of any operational errors nor
                does it warrant that it will be free of any virus, computer contaminant, worm, or other harmful components. The subscription of a user shall be subject to Quotas as applicable and as advised. E-Mails provided
                as part of contact details are expected to be genuine and access to such email accounts is available to authorised personnel only.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                ZippyOPS Consulting Services LLP shall not be liable for any loss or damage sustained by reason of any disclosure (inadvertent or otherwise) of any information concerning the user's account and / or information
                relating to or regarding online transactions using credit cards / debit cards and / or their verification process and particulars nor for any error, omission or inaccuracy with respect to any information so disclosed
                and used whether or not in pursuance of a legal process or otherwise.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                Payments for the services offered by Collab.labasservice.com shall be on a 100% advance basis. Refund if any will be at the sole discretion of ZippyOPS. ZippyOPS offers no guarantees whatsoever for the accuracy or timeliness
                of the refunds reaching the Customers card/bank accounts. ZippyOPS gives no guarantees of server uptime or applications working properly. All is on a best effort basis and liability is limited to refund of amount only. ZippyOPS
                undertakes no liability for free services. ZippyOPS reserves its right to amend / alter or change all or any disclaimers or terms of agreements at any time without any prior notice. All terms / disclaimers whether specifically mentioned
                or not shall be deemed to be included if any reference is made to them.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                Unless otherwise specified and notwithstanding anything contained in any other agreement or arrangement, by whatever name called, the performance obligation of ZippyOPS (service provider) is to provide access of its on-line portal to the
                customer for the duration of the subscription period & reference to any usage, by whatever name called or any other performance obligation, if any, is to provide the upper limit for consumption, which by itself, does not create any additional
                performance obligation upon ZippyOPS.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                Subscriber/user acknowledges and agrees that ZippyOPS/Collab.labasservice.com, at its sole discretion and without prejudice to other rights and remedies that it may have under the applicable laws, shall be entitled to set off the amount paid or payable
                by a subscriber/user against any amount(s) payable by Subscriber/user to ZippyOPS under any other agreement or commercial relationship towards other products/services.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                ZippyOPS Consulting Services LLP further reserves its right to post the data on the website collab.labasservice.com or on such other affiliated sites and publications as ZippyOPS Consulting Services LLP may deem fit and proper at no extra cost to the subscriber / user.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                The subscription / agreement between ZippyOPS and the subscriber / user is not a "non-poach agreement" nor can the same be termed or used as an alternative to "non-poach agreement" in as much as ZippyOPS / collab.labasservice.com is a public site and all information posted
                by ZippyOPS goes to the public domain except information / data which is specifically assigned a non-public / private character.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                Any agreement for a subscription / usage entered into by ZippyOPS does not confer exclusivity of service on any subscriber / user.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                ZippyOPS Consulting Services LLP will not be party to any legal proceedings between a user (e.g. a subscriber) and a party contracted through the site. In case ZippyOPS Consulting Services LLP is implicated in any legal proceedings, costs will be recovered from the party that
                names ZippyOPS Consulting Services LLP ZippyOPS however will abide with any court order served on it through due process. ZippyOPS controls and operates this Platform from its headquarters in Noida and makes no representation that the materials on Collab.labasservice.com are
                appropriate or available for use in other locations. If you use this Website from other locations, you are responsible for compliance with applicable local laws including but not limited to the export and import regulations of other countries.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                In case a person using the world wide web/internet receives a spam or virus which includes a link to collab.labasservice.com or to any other site maintained, operated or owned by ZippyOPS, it should not be held responsible for the same. ZippyOPS assumes no responsibility for such mails.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                The services provided by the websites maintained, operated or owned by ZippyOPS do not extend to acting as an agent (express or implied) on behalf of any subscriber or user.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                ZippyOPS has no agents and does not operate through any agents save for those specifically mentioned on the home page of the website.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                The Terms and conditions mentioned above regulate the usage of collab.labasservice.com. Any person using collab.labasservice.com in violation of the stipulations contained in the Terms and Conditions of collab.labasservice.com shall render himself/herself liable to appropriate action in a
                court of law both civil and criminal.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                BY ACCEPTING THESE TERMS AND CONDITIONS, YOU AGREE TO INDEMNIFY AND OTHERWISE HOLD HARMLESS ZippyOPS, ITS DIRECTORS, OFFICERS, EMPLOYERS, AGENTS, SUBSIDIARIES, AFFILIATES AND OTHER PARTNERS FROM ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR EXEMPLARY DAMAGES ARISING OUT OF,
                RELATING TO, OR RESULTING FROM YOUR USE OF THE SERVICES OBTAINED THROUGH COLLAB.LABASSERVICE.COM INCLUDING BUT NOT LIMITED TO INFORMATION PROVIDED BY YOU OR ANY OTHER MATTER RELATING TO COLLAB.LABASSERVICE.COM. ANY REFERENCE TO DUTIES AND TAXES ETC IN THESE TERMS OF USE SHALL INCLUDE GOODS
                AND SERVICES TAX (HEREIN REFERRED AS GST) FROM THE DATE GST LAW IS IMPLEMENTED IN INDIA. ANY ADDITIONAL TAX LIABILITY ARISING ON ACCOUNT OF INTRODUCTION OF GST (WHETHER ON ACCOUNT OF INCREASE IN RATE OR ANY CHANGE BROUGHT IN BY THE NEW TAX REGIME) WOULD BE RECOVERED OVER AND ABOVE THE AGREED CONTRACT PRICE / SERVICE FEE.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                If any dispute arises between a user/users and ZippyOPS arising out of use of Collab.labasservice.com or thereafter, in connection with the validity, interpretation, implementation or alleged breach of any provision of these Terms and Conditions, the dispute shall be referred to a sole arbitrator who shall be an independent
                and neutral third party identified by the Company. Decision of the arbitrator shall be final and binding on both the parties to the dispute. The place of arbitration shall be New Delhi, India. The Arbitration & Conciliation Act, 1996 as amended, shall govern the arbitration proceedings.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                These Terms and Conditions shall be governed by the laws of Republic of India. The exclusive forum for any disputes arising out of or relating to these Terms of Use shall be a court of law located in Chennai, India.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                ZippyOPS, ZippyOPS India, ZippyOPS and ZippyOPS Consulting Services LLP are used interchangeably and are synonymous.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                The user of collab.labasservice.com is subject to the <span style={{ color: 'blue', cursor: 'pointer' }} onClick={handlePrivacyPolicyClick}>Privacy Policy</span> available through this link.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                In case of non-compliance of these Terms and Conditions or Privacy Policy ZippyOPS may terminate usage rights and take down any offending information that might have been uploaded by such subscriber/user.
            </DialogContentText>
            <DialogContentText
                id="alert-dialog-description"
                tabIndex={-1}
                style={{
                    fontSize: 15,
                    marginTop: 10,
                    WebkitTextStrokeWidth: "thin",
                }}
            >
                <strong>Note:</strong> The terms in this agreement may be changed by ZippyOPS at any time. ZippyOPS is free to offer its services to any client/prospective client without restriction.
            </DialogContentText>
        </>
    );
};

export default TrainerTermsAndCondition;
